/**
 * O que faz: inicia o React e registra recarga automática quando um JS antigo some após deploy.
 * Onde usa: ponto de entrada do CRM.
 * Conexões: App, CSS global e recarregarAposFalhaDeChunk.
 * Tabelas: nenhuma.
 * Data: 28/08/2026
 */
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import {
  limparMarcacaoDeRecargaDeChunk,
  registrarRecargaAutomaticaDeChunk,
} from '@/lib/recarregarAposFalhaDeChunk'

// Motivo: se o usuário já estava no CRM e um deploy apagou o arquivo do Chat, o Vite avisa aqui.
registrarRecargaAutomaticaDeChunk()
// Motivo: a recarga anterior funcionou; libera uma nova tentativa se houver outro deploy nesta aba.
limparMarcacaoDeRecargaDeChunk()

createRoot(document.getElementById("root")!).render(<App />);
